import React from "react";
import ReactGA from "react-ga";
import { hotjar } from "react-hotjar";

import Routes from "./Routes";

import {
  GOOGLE_ANALYTICS_ID,
  HOTJAR_ID,
  HOTJAR_SNIPPET_VERSION,
} from "environment";

if (GOOGLE_ANALYTICS_ID) {
  ReactGA.initialize(GOOGLE_ANALYTICS_ID);
}

if (HOTJAR_ID && HOTJAR_SNIPPET_VERSION) {
  hotjar.initialize(HOTJAR_ID, HOTJAR_SNIPPET_VERSION);
}

const App = () => {
  return <Routes id="App" />;
};

export default App;
